// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2LWF1","tab":"ProcedureTabs_tab__3fcVV"};